/* ============================================================================
   assets/r24-pdp-tabs.js — ausgelagert aus sections/r24-product-tabs.liquid (Audit 31.10.2026,
   Vorschlag 11: 20 KB Inline-JS je Produktseite → gecachte Datei).
   Ab jetzt ist DIESE Datei die Quelle der Wahrheit; im Liquid steht an der alten Stelle nur
   der Skript-Tag (Verweis R24-JS-AUSGELAGERT). Code unveraendert (er enthielt kein Liquid).
   Pruefung: npm run css:check (audit/perf/extract-css.mjs, Abschnitt "scripts").
   ============================================================================ */
(function(){
  document.querySelectorAll('[data-r24tb]').forEach(function(root){
    /* EVENT-DELEGATION statt Einzel-Listener: ein Handler auf der Leiste gilt für
       ALLE Tabs — auch für später eingefügte (z. B. den Konfigurator-Tab) und für
       Tabs, die durch ein Re-Render ausgetauscht werden. Damit kann kein Tab mehr
       „tot" sein, weil sein Listener beim Binden noch nicht existierte. */
    function activate(t){
      if(!t) return;
      var id = t.getAttribute('data-tab');
      root.querySelectorAll('[data-tab]').forEach(function(x){
        var on = x === t;
        x.classList.toggle('is-active', on);
        /* Vorleseprogramme brauchen aria-selected — die Klasse allein sagt ihnen nichts. */
        if(x.getAttribute('role') === 'tab') x.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      root.querySelectorAll('[data-panel]').forEach(function(pn){
        var on = pn.getAttribute('data-panel') === id;
        pn.classList.toggle('is-active', on);
        /* Das Bewertungs-Panel bleibt technisch gerendert (Judge.me hydriert nur
           gerenderte Knoten) und liegt sonst weit links außerhalb des Bildes. Ohne
           `inert` konnte man mit der Tabulatortaste in unsichtbare Bedienelemente
           laufen. `inert` wird von Browsern ohne Unterstützung schlicht ignoriert. */
        if(pn.getAttribute('data-panel') === 'rev'){ if(on) pn.removeAttribute('inert'); else pn.setAttribute('inert',''); }
      });
      /* Wechsel bei haftender Leiste: neuen Inhalt von seinem Anfang zeigen, nicht mitten drin. */
      var bar = root.querySelector('.r24tb-bar');
      if (bar && bar.classList.contains('is-stuck')) {
        var y = window.pageYOffset, hd = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--r24hd-offset')) || 0;
        var pad = parseFloat(getComputedStyle(root).paddingTop) || 0;
        window.scrollTo(0, Math.max(0, root.getBoundingClientRect().top + pad + y - hd));
        if (window.R24TabsSettle) window.R24TabsSettle(bar);
      }
    }
    root.addEventListener('click', function(e){
      var t = e.target.closest && e.target.closest('[data-tab]');
      if(!t || !root.contains(t)) return;
      e.preventDefault();
      activate(t);
    });
    /* Tastaturbedienung nach WAI-ARIA: Pfeile blättern, Pos1/Ende springen. */
    root.addEventListener('keydown', function(e){
      var t = e.target.closest && e.target.closest('[data-tab]');
      if(!t || !root.contains(t)) return;
      var keys = { ArrowRight:1, ArrowLeft:-1, Home:'first', End:'last' };
      if(!(e.key in keys)) return;
      var list = [].slice.call(root.querySelectorAll('[data-tab]'));
      var i = list.indexOf(t);
      if(i < 0) return;
      e.preventDefault();
      var k = keys[e.key];
      var n = k === 'first' ? 0 : k === 'last' ? list.length - 1 : (i + k + list.length) % list.length;
      list[n].focus();
      activate(list[n]);
    });
    /* Startzustand: das Bewertungs-Panel ist beim Laden nicht aktiv. */
    var revPanel = root.querySelector('[data-panel="rev"]');
    if(revPanel && !revPanel.classList.contains('is-active')) revPanel.setAttribute('inert','');

    /* ── Leerraum-Reinigung: Import-HTML enthält Platzhalter-Blöcke, die NUR aus
       &nbsp;, <br> oder leeren <span> bestehen. Sie sind nicht `:empty`, erzeugen
       aber große Löcher. Hier werden sie automatisch entwertet — unabhängig davon,
       wie der Text eingepflegt wurde. Rein visuell: es wird nichts gelöscht, was
       Text, Bild oder Liste enthält. ── */
    root.querySelectorAll('.r24tb-desc .body').forEach(function(body){
      body.querySelectorAll('p,div,span,h1,h2,h3,h4,h5,h6').forEach(function(el){
        if (el.querySelector('img,svg,video,iframe,li,table')) return;      /* echter Inhalt */
        var txt = (el.textContent || '').replace(/ /g, ' ').trim();     /* &nbsp; → Space */
        if (txt === '') el.setAttribute('data-r24-blank', '');
      });
      /* Führende/abschließende Leerzeilen am Blockanfang/-ende entfernen. */
      var kids = body.children;
      while (kids.length && kids[0].hasAttribute && kids[0].hasAttribute('data-r24-blank')) kids[0].remove();
      while (kids.length && kids[kids.length-1].hasAttribute && kids[kids.length-1].hasAttribute('data-r24-blank')) kids[kids.length-1].remove();
    });

    /* ── Tote Bestandteil-Verweise entschärfen ──
       Ein Bestandteil kann inzwischen gelöscht/umbenannt sein — der Link führt dann
       auf 404. Die ZEILE bleibt (der Artikel gehört weiterhin zum Set), nur der
       Verweis wird zu reinem Text. Gegenstück zu „Teil von N Sets", wo die ganze
       Karte verschwindet, weil sie ausschließlich ein Navigationsziel ist. */
    var links = [].slice.call(root.querySelectorAll('.r24set__tbl tbody tr.is-link td.c-nm a[href^="/products/"]'));
    /* Vorher: EINE Abfrage pro Zeile, sofort beim Laden, ohne Zusammenfassung —
       ein Set mit 20 Positionen feuerte 20 parallele Abfragen mitten in den
       Seitenaufbau, doppelte Positionen sogar mehrfach. Jetzt: je Handle nur EINE
       Abfrage (geteiltes Versprechen) und erst im Leerlauf, weil die Prüfung für
       die Darstellung unkritisch ist. */
    function checkLinks(){
      var seen = {};
      links.forEach(function(a){
        var h = (a.getAttribute('href') || '').split('/products/')[1];
        if(!h) return;
        /* Gemeinsamer Abruf mit dem Set-Konfigurator (window.R24PJ, max. 4 parallel):
           dasselbe Produkt wird auf der Seite nur EINMAL geladen (A16-09). */
        seen[h] = seen[h] || (window.R24PJ
          ? window.R24PJ(h).then(function(x){ return x ? x.ok : true; })
          : fetch('/products/' + h + '.js', {headers:{'Accept':'application/json'}})
              .then(function(r){ return r.ok; })
              .catch(function(){ return true; }));   /* Netzfehler ≠ gelöscht → Link bleibt */
        seen[h].then(function(alive){
          if(alive) return;
          var span = document.createElement('span');
          span.textContent = a.textContent;
          span.className = 'r24set__gone';
          span.title = 'Dieser Artikel ist einzeln nicht mehr verfügbar';
          a.replaceWith(span);
          var tr = span.closest('tr'); if(tr) tr.classList.remove('is-link');
        });
      });
    }
    if(links.length) (window.requestIdleCallback || function(fn){ return setTimeout(fn, 400); })(checkLinks);
  });

  /* Verweise auf einen Reiter von außerhalb (Runde 3): „zzgl. Versand“ in der Kaufbox öffnet
     „Versand & Lieferung“ und scrollt dorthin — vorher war „Versand“ ein <u> mit Hand-Zeiger
     ohne Funktion. Ohne passenden Reiter bleibt es ein normaler Anker. */
  document.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('[data-r24tb-open]');
    if(!a) return;
    var root = document.querySelector('[data-r24tb]');
    var t = root && root.querySelector('[data-tab="' + a.getAttribute('data-r24tb-open') + '"]');
    if(!t) return;
    e.preventDefault();
    t.click();
    if (window.R24TabsAccOpen) window.R24TabsAccOpen(root, a.getAttribute('data-r24tb-open'));
    var rm = false; try { rm = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (err) { rm = false; }
    root.scrollIntoView({ block: 'start', behavior: rm ? 'auto' : 'smooth' });
    try { t.focus({ preventScroll: true }); } catch (err) { t.focus(); }
  });
})();

/* „Set individuell zusammenstellen" bekommt einen EIGENEN Tab direkt neben
   „Beschreibung". Der Konfigurator ist eine eigene Section — statt ihn zu
   duplizieren, wird der echte Knoten zur Laufzeit in ein neues Tab-Panel
   VERSCHOBEN. So bleiben seine Live-Preise, Mengen und der Warenkorb-Button
   unverändert funktionsfähig; es gibt keine zweite Kopie im DOM. */
(function () {
  var root = document.querySelector('[data-r24tb]');
  if (!root) return;
  var bar = root.querySelector('.r24tb-bar');
  if (!bar) return;

  function moveIn() {
    var kf = document.getElementById('r24-konfig');
    if (!kf) return false;
    if (root.contains(kf)) return true;            /* bereits verschoben */

    var host = kf.parentElement;                   /* evtl. leere Section-Hülle */
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'r24tb-t';
    btn.setAttribute('data-tab', 'konfig');
    /* Gleiche Auszeichnung wie die serverseitig gerenderten Reiter — sonst wäre
       ausgerechnet der nachträglich eingehängte Reiter der einzige ohne ARIA. */
    btn.setAttribute('role', 'tab');
    btn.id = 'r24tb-tab-konfig';
    btn.setAttribute('aria-controls', 'r24tb-panel-konfig');
    btn.setAttribute('aria-selected', 'false');
    /* Eigenes, festes Markup (kein Fremdinhalt): Symbol wie die übrigen Reiter. */
    btn.innerHTML = '<svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12M20 18h0"/><circle cx="16" cy="6" r="2"/><circle cx="10" cy="12" r="2"/><circle cx="18" cy="18" r="2"/></svg>Set individuell zusammenstellen';
    var desc = bar.querySelector('[data-tab="desc"]');
    if (desc && desc.nextSibling) bar.insertBefore(btn, desc.nextSibling);
    else bar.appendChild(btn);

    var panel = document.createElement('div');
    panel.className = 'r24tb-panel';
    panel.setAttribute('data-panel', 'konfig');
    panel.id = 'r24tb-panel-konfig';
    panel.setAttribute('role', 'tabpanel');
    panel.setAttribute('aria-labelledby', 'r24tb-tab-konfig');
    panel.setAttribute('tabindex', '0');
    panel.appendChild(kf);
    /* Mobil: Konfigurator direkt nach der Beschreibung (gleiche Reihenfolge wie die Reiter). */
    var descPanel = root.querySelector('[data-panel="desc"]');
    var anchor = descPanel && (descPanel.closest('.r24tb-grp') || descPanel);
    if (anchor && anchor.parentNode === root && anchor.nextSibling) root.insertBefore(panel, anchor.nextSibling); else root.appendChild(panel);
    if (window.R24TabsAcc) window.R24TabsAcc(root);

    /* Zurückbleibende leere Hülle würde als Leerband stehen → ausblenden. */
    if (host && host !== root && !host.querySelector('*')) host.style.display = 'none';

    return true;   /* Klick übernimmt die Delegation oben */
  }

  if (!moveIn()) {                                  /* Konfigurator lädt evtl. später */
    setTimeout(moveIn, 600);
    setTimeout(moveIn, 1600);
    setTimeout(moveIn, 3200);
  }
})();

/* Runde 8 — Akkordeon für Handy/Tablet: je Reiter-Knopf ein Kopf vor seinem Panel (gleiche Symbole/Zähler).
   window.R24TabsAcc(root) ist idempotent und wird nach dem Einhängen des Konfigurator-Reiters erneut gerufen. */
(function () {
  var CHEV = '<svg class="chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
  function build(root) {
    [].forEach.call(root.querySelectorAll('.r24tb-bar [data-tab]'), function (t) {
      var id = t.getAttribute('data-tab');
      var pn = root.querySelector('[data-panel="' + id + '"]');
      if (!pn || root.querySelector('.r24tb-acc[data-acc="' + id + '"]')) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'r24tb-acc'; b.setAttribute('data-acc', id);
      b.setAttribute('aria-controls', pn.id || ''); b.id = 'r24tb-acc-' + id;
      var ic = t.querySelector('.ic'), n = t.querySelector('.r24tb-n');
      var label = (t.textContent || '').replace(n ? n.textContent : '', '').replace(/\s+/g, ' ').trim();
      /* Eigenes Markup aus unseren eigenen Knöpfen (Symbol, Zähler) — kein Fremdinhalt. */
      b.innerHTML = (ic ? ic.outerHTML : '') + '<span class="lbl"></span>' + (n ? n.outerHTML : '') + CHEV;
      b.querySelector('.lbl').textContent = label;
      b.setAttribute('aria-expanded', pn.classList.contains('is-open') ? 'true' : 'false');
      /* Gruppe je Abschnitt: der haftende Kopf bleibt nur über SEINEM Inhalt stehen. */
      var g = document.createElement('div'); g.className = 'r24tb-grp';
      pn.parentNode.insertBefore(g, pn); g.appendChild(b); g.appendChild(pn);
    });
  }
  function toggle(root, id, force) {
    var b = root.querySelector('.r24tb-acc[data-acc="' + id + '"]'), pn = root.querySelector('[data-panel="' + id + '"]');
    if (!b || !pn) return;
    var open = typeof force === 'boolean' ? force : !pn.classList.contains('is-open');
    pn.classList.toggle('is-open', open);
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (id === 'rev') { if (open) pn.removeAttribute('inert'); else pn.setAttribute('inert', ''); }
  }
  window.R24TabsAcc = function (root) { build(root); };
  window.R24TabsAccOpen = function (root, id) { toggle(root, id, true); };
  /* Haftzustand (.is-stuck) für Leiste und offene Köpfe: steht das Element an seiner Haftkante, während der Bereich
     darüber schon weggescrollt ist? Ein passiver, rAF-gedrosselter Scroll-Handler; nur Klassenwechsel. */
  window.R24TabsTop = function (el) { return parseFloat(getComputedStyle(el).top) || 0; };
  /* Nach dem Sprung wächst der Seitenkopf evtl. noch (Kompakt → voll, 0,3 s) — danach nachmessen und
     den Abschnittsanfang knapp unter seine Unterkante rücken (kleiner Schritt, blendet den Kopf nicht aus). */
  function settle(el) {
    function fix() {
      var hd = document.querySelector('.r24hd-sticky'), edge = 0;
      if (hd && !hd.classList.contains('is-hidden')) edge = Math.max(0, hd.getBoundingClientRect().bottom);
      var d = el.getBoundingClientRect().top - edge;
      if (d < -1 || d > 24) window.scrollBy(0, d);
    }
    setTimeout(fix, 380); setTimeout(fix, 900);   /* 2. Blick: Kopf-Übergänge (Einblenden + Aufklappen) sind dann sicher fertig */
  }
  window.R24TabsSettle = settle;
  var tick = 0;
  function stuck() {
    tick = 0;
    [].forEach.call(document.querySelectorAll('[data-r24tb] .r24tb-bar, [data-r24tb] .r24tb-acc'), function (el) {
      var on = false;
      if (el.offsetParent !== null && getComputedStyle(el).position === 'sticky') {
        var top = window.R24TabsTop(el), box = el.parentNode.getBoundingClientRect();
        on = el.getBoundingClientRect().top <= top + 1 && box.top < top - 1 && box.bottom > top + el.offsetHeight;
      }
      if (el.classList.contains('is-stuck') !== on) el.classList.toggle('is-stuck', on);
    });
  }
  window.addEventListener('scroll', function () { if (!tick) tick = requestAnimationFrame(stuck); }, { passive: true });
  window.addEventListener('resize', function () { if (!tick) tick = requestAnimationFrame(stuck); }, { passive: true });
  tick = requestAnimationFrame(stuck);
  [].forEach.call(document.querySelectorAll('[data-r24tb]'), function (root) {
    build(root);
    root.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.r24tb-acc');
      if (!b || !root.contains(b)) return;
      e.preventDefault();
      var id = b.getAttribute('data-acc');
      var wasStuck = b.classList.contains('is-stuck');
      toggle(root, id);
      var top = window.R24TabsTop ? window.R24TabsTop(b) : 0, g = b.parentNode;
      /* Haftenden Kopf zugeklappt: an den Abschnittsanfang springen, sonst stünde man mitten im Folgeinhalt. */
      /* Ziel = Höhe des SICHTBAREN Seitenkopfs: der Rücksprung nach oben blendet ihn wieder ein. */
      if (wasStuck && b.getAttribute('aria-expanded') === 'false') {
        var hd = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--r24hd-offset')) || 0;
        window.scrollTo(0, Math.max(0, g.getBoundingClientRect().top + window.pageYOffset - hd));
        settle(g);
        return;
      }
      /* Geöffneten Kopf oben halten, falls er aus dem Bild gerutscht ist. */
      var r = b.getBoundingClientRect();
      if (r.top < top) { var rm = false; try { rm = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (er) { rm = false; } window.scrollBy({ top: r.top - top, behavior: rm ? 'auto' : 'smooth' }); }
    });
  });
})();

/* Runde 5 — Ansichten (Großansicht per <dialog>), Bewertungs-Fallback, Bildreparatur. */
(function () {
  var root = document.querySelector('[data-r24tb]');
  if (!root) return;

  /* Großansicht: Pfeiltasten blättern, Esc schließt (dialog-Standard). Ohne dialog-Unterstützung
     öffnet das Bild in einem neuen Tab. */
  [].forEach.call(root.querySelectorAll('[data-r24-gal]'), function (gal) {
    var its = [].slice.call(gal.querySelectorAll('.r24tb-gal__it')), dlg = gal.querySelector('dialog'), cur = 0;
    if (!its.length || !dlg) return;
    var img = dlg.querySelector('img'), cap = dlg.querySelector('figcaption'), fig = dlg.querySelector('figure');
    /* Schnell blättern (Owner 23.09.2026): Breite passend zum Gerät statt immer 1600 px, Nachbarn
       vorgewärmt, Tausch erst nach dem Laden (mit Ladekreis), Wischen auf Telefonen. */
    var W = Math.min(1600, Math.ceil(Math.min(window.innerWidth || 1100, 1100) * (window.devicePixelRatio || 1) / 200) * 200), pre = {}, req = 0;
    function url(i) { return String(its[i].getAttribute('data-full') || '').replace(/([?&])width=\d+/, '$1width=' + W); }
    function warm(i) { i = (i + its.length) % its.length; var u = url(i); if (!pre[u]) { pre[u] = new Image(); pre[u].src = u; } return pre[u]; }
    function show(i) {
      cur = (i + its.length) % its.length;
      var n = ++req, u = url(cur), alt = its[cur].getAttribute('data-alt') || '', im = warm(cur);
      cap.textContent = (cur + 1) + ' / ' + its.length + (alt ? ' · ' + alt : '');
      function swap() { if (n !== req) return; img.src = u; img.alt = alt; fig.classList.remove('is-loading'); }
      if (im.complete && im.naturalWidth) swap(); else { fig.classList.add('is-loading'); im.addEventListener('load', swap, { once: true }); im.addEventListener('error', swap, { once: true }); }
      warm(cur + 1); warm(cur - 1);
    }
    var tx = null, ty = null;
    fig.addEventListener('touchstart', function (e) { var t = e.changedTouches[0]; tx = t.clientX; ty = t.clientY; }, { passive: true });
    fig.addEventListener('touchend', function (e) { if (tx === null) return; var t = e.changedTouches[0], dx = t.clientX - tx, dy = t.clientY - ty; tx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) show(cur + (dx < 0 ? 1 : -1)); }, { passive: true });
    its.forEach(function (b, i) {
      b.addEventListener('click', function () {
        if (typeof dlg.showModal !== 'function') { window.open(b.getAttribute('data-full'), '_blank', 'noopener'); return; }
        show(i); dlg.showModal();
      });
    });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || (e.target.closest && e.target.closest('[data-x]'))) { dlg.close(); return; }
      if (e.target.closest && e.target.closest('[data-prev]')) show(cur - 1);
      if (e.target.closest && e.target.closest('[data-next]')) show(cur + 1);
    });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(cur - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(cur + 1); }
    });
  });

  /* Bewertungs-App eingehängt, aber rendert nichts (App deaktiviert, Skript blockiert)?
     Dann nach dem Laden den ehrlichen Leerzustand zeigen statt eines leeren Reiters. */
  var empty = root.querySelector('[data-r24-rv-empty]'), box = root.querySelector('.r24tb-jdgm');
  if (empty && empty.hidden && box) {
    var check = function () {
      var txt = (box.textContent || '').replace(/\s+/g, '');
      if (txt.length < 20 && !box.querySelector('iframe,form,img')) empty.hidden = false;
    };
    var later = function () { setTimeout(check, 3500); };
    if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
  }

  /* Set-Tabelle: Bilder ohne gespeicherte URL live holen; bereits gescheiterte reparieren. */
  var fix = function () {
    if (!window.R24ImgFix) return;
    [].forEach.call(root.querySelectorAll('.r24set__tbl img[data-r24-h]'), function (im) {
      if (im.hasAttribute('data-r24-live') || (im.complete && im.getAttribute('src') && im.naturalWidth === 0)) window.R24ImgFix(im);
    });
  };
  var setBtn = root.querySelector('[data-tab="set"]');
  if (setBtn) setBtn.addEventListener('click', fix);
  (window.requestIdleCallback || function (fn) { return setTimeout(fn, 800); })(fix);
})();

/* Kein Verschiebe-Skript mehr nötig: die Auto-Platzierung von Judge.me ist im
   Theme deaktiviert, der Container oben im Tab ist die einzige Instanz. */

/* Aufgeräumt: Der Ausblende-Workaround entfällt — Judge.me platziert dank
   deaktiviertem Auto-install keine zweite Instanz mehr. Einzige Quelle ist der
   Container im Bewertungen-Tab. */
